(function () {
  // Mobile menu close
  document.querySelectorAll('[data-mnav-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = btn.closest('[data-mnav]');
      if (d) d.removeAttribute('open');
    });
  });

  // Collection sort
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Money formatting
  function formatMoney(cents, format) {
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    function fmt(n, decimals, thousands, decimal) {
      var num = (n / 100).toFixed(decimals);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    switch (type) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  // Product variant picker
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format') || 'Rs {{amount_no_decimals}}';
    var idInput = root.querySelector('input[name="id"]');
    var btn = root.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var fieldsets = root.querySelectorAll('[data-option]');

    function update() {
      var selected = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
        var lbl = fs.querySelector('[data-option-value]');
        if (lbl && checked) lbl.textContent = checked.value;
      });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!variant) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-label-unavailable');
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      btn.disabled = !variant.available;
      var addLabel = btn.getAttribute('data-label-add');
      if (btn.hasAttribute('data-show-price')) addLabel += ' — ' + formatMoney(variant.price, moneyFormat);
      btn.textContent = variant.available ? addLabel : btn.getAttribute('data-label-soldout');
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media) {
        var m = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        var track = root.querySelector('[data-track]');
        var gallery = root.querySelector('.gallery');
        if (m && track) {
          track.scrollTo({ left: m.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        } else if (m && gallery) {
          if (window.innerWidth < 990) {
            gallery.scrollTo({ left: m.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          } else {
            gallery.insertBefore(m, gallery.firstChild);
          }
        }
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', update);
    });
  });
  // Product image slider
  document.querySelectorAll('[data-track]').forEach(function (track) {
    var stage = track.parentElement;
    var prev = stage.querySelector('[data-prev]');
    var next = stage.querySelector('[data-next]');
    var cur = stage.querySelector('[data-current]');
    var slides = track.children;
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function sync() {
      var i = index();
      if (cur) cur.textContent = i + 1;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    function go(d) { track.scrollTo({ left: (index() + d) * track.clientWidth, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); });
    sync();
  });
  // Header: solid on scroll when over homepage image
  var header = document.querySelector('[data-header].is-overlay');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var mnav = header.querySelector('[data-mnav]');
    if (mnav) mnav.addEventListener('toggle', function () { if (mnav.open) header.classList.add('is-solid'); else onScroll(); });
  }

  // Footer columns: always open on desktop
  function syncFooter() {
    var desk = window.matchMedia('(min-width: 990px)').matches;
    document.querySelectorAll('[data-fcol]').forEach(function (d, i) { if (desk) d.open = true; });
  }
  syncFooter();
  window.addEventListener('resize', syncFooter);

  // Country selector
  document.querySelectorAll('[data-autosubmit]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });
  // Creator spotlight: load YouTube only on click
  document.querySelectorAll('[data-yt]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + b.getAttribute('data-yt') + '?autoplay=1&rel=0';
      f.title = 'YouTube video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      b.replaceWith(f);
    });
  });
})();
